import { Box, Typography, Checkbox } from "@mui/material";

export const CheckboxWithLabel = ({ value, title, onChange }: ICheckboxWithLabelProps) => (
  <Box display="flex" gap={0.5} alignItems="center">
    <Checkbox
      checked={value}
      onChange={onChange}
    />
    <Typography fontWeight={600} variant="subtitle2">{title}</Typography>
  </Box>
)